import { ResourceKey } from '.';
import { ShapeBaseAttribute } from './base';

/** 视频配色数据（按 colorGroup 隔离） */
export type VideoColorDataItem = {
  videoSrc?: string;
  videoName?: string;
  videoFps?: number;
};

export class SpriteAttribute extends ShapeBaseAttribute {
  /** 动效类型：序列帧或视频 */
  spriteType: 'sprite' | 'video' = 'sprite';

  /**
   * 重复次数
   *
   * @memberof SpriteAttribute
   */
  repeatCount = 1;

  /**
   * 是否重复播放
   *
   * @memberof SpriteAttribute
   */
  infinite = false;

  /**
   *  序列帧帧率
   *
   * @memberof SpriteAttribute
   */
  spriteFps = 20;

  resources: {
    images?: LayerResourceItem;
    videoPreview?: LayerResourceItem;
    /**
     * ifttt无数据时显示的图片
     */
    iftttEmptyImage?: LayerResourceItem;

    // 其他视频预览图
    // videoPreview_1?: LayerResourceItem;
    // videoPreview_2?: LayerResourceItem;

    // 表示第n个序列帧
    // images_n?: LayerResourceItem;
  } = {};

  /**
   * Video资源src
   */
  videoSrc?: string;

  /**
   * Video资源名称
   */
  videoName?: string;

  /**
   * Video帧率
   */
  videoFps?: number;

  /**
   * 视频按配色/样式隔离的数据
   * key 为 colorGroup id，value 为该样式下的视频配置
   * 当此字段有值时优先使用，否则回退到 videoSrc/videoName/videoFps
   */
  videoColorData?: { [colorGroup: string]: VideoColorDataItem };

  /** 序列帧默认索引，用于画布中显示使用 */
  spriteDefaultIndex = 0;

  videoTypeToShow: 'video' | 'image' = 'video';

  // 多个视频资源时，其他资源数据
  spriteExtra: {
    id: string;

    w: number;
    h: number;

    // 视频配置
    videoSrc?: string;
    videoName?: string;
    videoFps?: number;
    videoPreviewName?: ResourceKey;

    /**
     * 视频按配色/样式隔离的数据
     * key 为 colorGroup id，value 为该样式下的视频配置
     * 当此字段有值时优先使用，否则回退到 videoSrc/videoName/videoFps
     */
    videoColorData?: { [colorGroup: string]: VideoColorDataItem };

    // 序列帧配置
    spriteImagesName?: ResourceKey;
    spriteDefaultIndex?: number;
  }[] = [];

  /**
   * 存在多个资源时，要播放的资源id
   * 默认播放第一个视频
   */
  extraIdToPlay = '';
}
